import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { themeColorSet, ThemedText, ThemedView } from "@app/theme";
import {Info } from '@app/sharedComponents/Icons/Icons';
import Button from "@app/sharedComponents/Button/Button";
import { ScrollView } from "react-native";
import { formatIndianCurrency } from "@app/utils/utility";

const ShortFallLearnMore = ({navigation,route}) =>{
    const {recommendedUtilisationPercent,currentUtilisationPercent,drawingPower,principalOutstandingAmount,recommendedAmount,recommendedUtilisation} = route?.params?.shortFallDetails || {};
    return(
        <>
        <PageHeaders pageName={route?.name} navigation={navigation} />
        <ThemedView backgroundColor="bg-fill-info" px="lg" py="md" flexDirection="row">
            <ThemedView style={{justifyContent :'flex-start' , marginRight: 4}}  >
        <Info weight="fill" size={16} color={themeColorSet['icon-secondary']} />
         </ThemedView>
            <ThemedText  variant="b4r" color="text-primary">To prevent any potential future shortfalls, we recommend maintaining utilisation at 95% of your credit limit and repaying the recommended amount.</ThemedText>
        </ThemedView>
        <ScrollView style={{flex:1, backgroundColor:themeColorSet["bg-surface-primary"]}} contentContainerStyle={{padding:16}}>
            <ThemedText variant="b2s" color="text-primary" mb="lg">
            Recommended repayment
            </ThemedText>
            <ThemedView p="md" borderWidth={1} borderColor="border-primary" borderRadius="lg" backgroundColor="bg-surface-primary">
                <ThemedView flexDirection="row" justifyContent="space-between" mb="md">
                    <ThemedText variant="b3r" color="text-secondary">Credit limit</ThemedText>
                    <ThemedText variant="b3r" color="text-secondary">₹{formatIndianCurrency(drawingPower)}</ThemedText>
                </ThemedView>
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3r" color="text-secondary">Current utilisation</ThemedText>
                    <ThemedText variant="b3r" color="text-secondary">₹{formatIndianCurrency(principalOutstandingAmount)} ({currentUtilisationPercent}%)</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-primary" width={"100%"} my="md" />

                <ThemedView flexDirection="row" justifyContent="space-between"  mb="md">
                    <ThemedText variant="b3r" color="text-secondary">Recommended utilisation</ThemedText>
                    <ThemedText variant="b3r" color="text-secondary">₹{formatIndianCurrency(recommendedUtilisation)}({recommendedUtilisationPercent}%)</ThemedText>
                </ThemedView>
                <ThemedView flexDirection="row" justifyContent="space-between" mb="md">
                    <ThemedText variant="b3s" color="text-primary">Recommended repayment</ThemedText>
                    <ThemedText variant="b3s" color="text-primary">₹{formatIndianCurrency(recommendedAmount)}</ThemedText>
                </ThemedView>
            </ThemedView>
        </ScrollView>
        <ThemedView backgroundColor="bg-surface-primary" p="lg" pt="2xl" borderTopWidth={1} borderTopColor="border-primary">
            <Button size="MD" label="Ok, got it!" handlePress={()=>{navigation.goBack()}} />
        </ThemedView>
        </>
    )
}

export default ShortFallLearnMore;